import http from './http'

// 获取列表
export function pageList (data) {
  return http.post('/client/sync/pagelist', data)
}

// 删除版本
export function removeVersion (key, version) {
  return http.delete(`/client/sync/${key}/${version}`)
}

// 删除同步项
export function removeSync (key) {
  return http.delete(`/client/sync/${key}`)
}

export function shareInfo (params) {
  return http.get(`/client/share/sync/info?key=${params.key}&version=${params.version}`)
}

export function share (params) {
  return http.post('/client/share', params)
}

export function shareList (data) {
  return http.get(`/client/share/user/sharelist?dataKey=${data.dataKey}&PageIndex=${data.PageIndex}&PageSize=${data.PageSize}`)
}
